import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20amber%20abstract%20gradient%20background%20with%20soft%20flowing%20curves%20and%20gentle%20light%20rays%2C%20cinematic%20atmosphere%20with%20warm%20glowing%20highlights%2C%20modern%20minimalist%20streaming%20platform%20aesthetic%2C%20smooth%20texture%20with%20subtle%20depth%2C%20creative%20and%20artistic%20composition%2C%20no%20text%20or%20logos&width=1600&height=900&seq=mango-hero-bg&orientation=landscape"
        alt="芒果视频 - 免费高清视频平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-5 leading-tight">
          芒果视频
        </h1>
        <p className="text-base md:text-lg lg:text-xl text-background-50/85 mb-3 max-w-2xl mx-auto leading-relaxed">
          资源丰富 · 播放流畅 · 免费高清
        </p>
        <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-xl mx-auto leading-relaxed">
          作为蜜桃视频、糖豆视频之外的优质推荐，芒果视频为您提供海量影视资源，无广告纯净观影体验
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/recommend"
            className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/30"
          >
            <i className="ri-play-circle-line text-lg"></i>
            开始探索
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-7 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-full font-medium text-sm md:text-base hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          {[
            { value: '10万+', label: '影片资源' },
            { value: '1亿+', label: '活跃用户' },
            { value: '4.8', label: '用户评分' },
            { value: '无广告', label: '纯净体验' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-50/65 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}